// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsSection_container__JIyju"};